import { Box, Flex } from '@chakra-ui/react';
import React, { useState } from 'react';
import { getFromUrl } from '../../../api/Api';
import useRangeChange from '../../../hooks/useRangeChange';
import { Indexable } from '../../../interface';
import { colors } from '../../../theme/colors';
import {
  buildAnalyticsQuery,
  isAnalyticsQueryReady
} from '../../../utils/dateRange';
import Card from '../../Dashboard/Card';
import CardHeader from '../../Dashboard/CardHeader';
import NationalityRatioChart from './NationalityRatioChart';

const NationalityRatio = () => {
  interface GraphInterface {
    name: string;
    value: number;
  }

  const [data, setData] = useState([] as GraphInterface[]);
  const [countries, setCountries] = useState<string[]>([]);
  const {
    range,
    startDate,
    endDate,
    handleChange,
    handleStartDateChange,
    handleEndDateChange
  } = useRangeChange();
  const createChartData = (object: any) => {
    const chartData: any[] = [];
    for (const key in object) {
      if (key !== 'OTHER' && key !== 'null' && key !== 'undefined') {
        const item = {
          name: key,
          value: (object as Indexable)[key]
        };
        chartData.push(item);
      }
    }
    const validCountries = chartData.filter(
      (country: any) => country.value !== 0
    );
    setCountries(validCountries);
    setData(validCountries);
  };
  React.useEffect(() => {
    const getNationalRatio = async () => {
      if (!isAnalyticsQueryReady(range, startDate, endDate)) {
        setData([]);
        setCountries([]);
        return;
      }

      try {
        const query = buildAnalyticsQuery(range, startDate, endDate);
        const { data } = await getFromUrl(`cases/nationality/ratio?${query}`);
        if (typeof data === 'object') {
          createChartData(data);
        } else {
          setData([]);
          setCountries([]);
        }
      } catch (e: any) {
        return;
      }
    };
    getNationalRatio().catch((err) => console.error(err));
  }, [range, startDate, endDate]);

  return (
    <Card w='100%'>
      <Box py='24px' width='100%'>
        <CardHeader
          title='Cases By Location'
          handleChange={handleChange}
          value={range}
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
        />
        {data.length ? (
          <>
            <NationalityRatioChart data={data} />
          </>
        ) : (
          <Flex
            justifyContent='center'
            marginX='auto'
            marginY='40px'
            width='100%'
            color={colors.gray}
          >
            {range === 'CUSTOM' && (!startDate || !endDate)
              ? 'Select start and end dates'
              : 'No data available'}
          </Flex>
        )}
      </Box>
    </Card>
  );
};
export default NationalityRatio;
